module.exports = __webpack_public_path__ + "img/H3.217fc53c.png";